
<template>
  <div>
    <div>
      Informações extras
    </div>
    <div :style="newItem.item_extra_infos && newItem.item_extra_infos.length? 'border: solid 3px #eee; border-radius: 12px;' : ''">
      
      
      <v-row class="mx-5 my-2" style="border-left: solid 3px #ccc; border-radius: 12px;"  v-for="(item, idx) in newItem.item_extra_infos" :key="item.id">
        <v-col cols='12' class="pa-2">
          <v-row class="px-3" justify="start">
            <v-btn icon small color="error" @click="remove(idx)"> <v-icon>mdi-delete</v-icon> </v-btn>
            <span class="caption">#{{idx+1}}</span>
          </v-row>
          <v-select
            :items="infos"
            v-model="item.label_obj"
            label="Selecione o nome do campo"
            item-text="name"
            return-object
            @change="setItsId(idx)"
            color="secondary"
            item-color="secondary"
          ></v-select>
          <!-- {{ item.label }} -->
          <v-textarea outlined hide-details class="pb-2" v-if="item.label_obj && item.label_obj.name" v-model="item.value" :prepend-icon="item.label_obj.icon" :label="item.label_obj.name" color="secondary"></v-textarea>
        </v-col>
      </v-row>
      <v-btn x-small class="ml-3 my-2" color="secondary" :disabled="!can_add_more_extras" @click="addExtra()" rounded> <v-icon left small>mdi-plus</v-icon> extra </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'

export default {
  name: 'ItemExtraInfo',

  data() {
    return {
      newItem: this.$attrs.newItem,

      one_extra: {
        label_obj: {},
        extra_info_id: null,
        value: null,
      },
      loading_info: true,
      infos: [],

    }
  },
  methods: {
    setupEachExtra(){
      if (this.newItem.item_extra_infos && this.newItem.item_extra_infos.length){
        this.newItem.item_extra_infos = this.newItem.item_extra_infos.map(ei=> {
          let {extra_info_id} = ei
          let label_obj = this.infos.find(({id})=> id == extra_info_id)
          return {...ei, label_obj}
        })
      }
    },
    setItsId(idx){
      this.newItem.item_extra_infos[idx].extra_info_id = this.newItem.item_extra_infos[idx].label_obj.id
    },
    remove(idx){
      let extra = this.newItem.item_extra_infos[idx]
      if (extra.id >= 1){
        Api.ExtraInfo.deleteItemExtra(extra.id).then(()=> {
          this.newItem.item_extra_infos.splice(idx, 1)
          this.addNotification({type: 'success', msg: 'Removido com sucesso!'})
        })
      } else {
        this.newItem.item_extra_infos.splice(idx, 1)
      }
    },
    addExtra(){
      this.newItem.item_extra_infos.push({...this.one_extra, id: Math.random()})
    },
    getExtraInfo() {
      this.loading_info = true
      Api.ExtraInfo.indexByModel({model_name: 'solutions', model_id: this.solutionID}).then(r=>r.data).then(d=> {
        this.infos = [...d]
        this.setupEachExtra()
      }).finally(()=>{
        this.loading_info = false
      })
    },
    ...mapActions({
      addNotification: "Notification/add",
      // function: 'Module/action'
    })
  },
  mounted () {
    if (this.solutionID){
      this.getExtraInfo();
    }
  },
  computed: {
    can_add_more_extras() {
      if (this.newItem.item_extra_infos && this.newItem.item_extra_infos.length){
        return this.newItem.item_extra_infos.length < 4
      }
      return true
    },
    ...mapState({
      solutionID: (state) => state.Solution.solutionID,
      allSolutions: (state) => state.Solution.allSolutions,
    })
  },
  watch: {
    solutionID(nv,ov) {
      if (nv){
        this.getExtraInfo()
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>